var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048.88 1378.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12,.cls-50,.cls-51,.cls-53,.cls-63{fill:#fff;}.cls-1{opacity:0.57;}.cls-2{isolation:isolate;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#bdd0fb;}.cls-5{fill:#dce5fe;}.cls-6{fill:#91b3fa;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:#2b69b3;}.cls-11{opacity:0.68;}.cls-12{mix-blend-mode:soft-light;}.cls-13{fill:#7d97f4;}.cls-14{fill:#18174a;}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{clip-path:url(#clip-path);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{clip-path:url(#clip-path-2);}.cls-40{fill:url(#linear-gradient-28);}.cls-41{clip-path:url(#clip-path-3);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}.cls-50{opacity:0.59;}.cls-51{opacity:0.73;}.cls-52{fill:url(#linear-gradient-37);}.cls-53{opacity:0.87;}.cls-54{fill:url(#linear-gradient-38);}.cls-55{fill:url(#linear-gradient-39);}.cls-56{fill:url(#linear-gradient-40);}.cls-57{fill:url(#linear-gradient-41);}.cls-58{fill:url(#linear-gradient-42);}.cls-59{fill:url(#linear-gradient-43);}.cls-60{fill:url(#linear-gradient-44);}.cls-61{fill:url(#linear-gradient-45);}.cls-62{fill:url(#linear-gradient-46);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 702.36,
    x2: 2048.88,
    y2: 702.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1195.12,
    y1: 636.07,
    x2: 1599.63,
    y2: 636.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 208.64,
    y1: 600.17,
    x2: 749.26,
    y2: 600.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 204.89,
    y1: 1077.79,
    x2: 875.61,
    y2: 1077.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 731.83,
    y1: 873.05,
    x2: 921.83,
    y2: 787.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 586.78,
    y1: 676.15,
    x2: 550.78,
    y2: 954.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -10123.75,
    y1: 4949.75,
    x2: -10201.75,
    y2: 4785.75,
    gradientTransform: "matrix(-0.96, 0.26, 0.26, 0.96, -10882.93, 836.49)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -10083.05,
    y1: 4930.39,
    x2: -10161.05,
    y2: 4766.39,
    gradientTransform: "matrix(-0.96, 0.26, 0.26, 0.96, -10882.93, 836.49)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1582.02,
    y1: 834.39,
    x2: -1609.55,
    y2: 1061.38,
    gradientTransform: "matrix(-1, 0, 0, 1, -1120.34, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 961.12,
    y1: 748.65,
    x2: 941.02,
    y2: 929.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 964.93,
    y1: 708.85,
    x2: 889.34,
    y2: 948.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 919.48,
    y1: 743.92,
    x2: 899.39,
    y2: 924.77,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 923.8,
    y1: 695.86,
    x2: 848.21,
    y2: 935.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1005.44,
    y1: 753.47,
    x2: 985.34,
    y2: 934.32,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1014.11,
    y1: 724.4,
    x2: 938.52,
    y2: 963.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 840.69,
    y1: 735.17,
    x2: 820.6,
    y2: 916.02,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 854.08,
    y1: 673.83,
    x2: 778.49,
    y2: 913.04,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 885,
    y1: 740.09,
    x2: 864.91,
    y2: 920.94,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 903.26,
    y1: 689.37,
    x2: 827.67,
    y2: 928.58,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1296.24,
    y1: -6.56,
    x2: 1232.24,
    y2: 245.44,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1331.6,
    y1: 2.42,
    x2: 1267.6,
    y2: 254.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1343.11,
    y1: 5.35,
    x2: 1279.11,
    y2: 257.35,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1394.47,
    y1: 18.39,
    x2: 1330.47,
    y2: 270.39,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1404.12,
    y1: 20.84,
    x2: 1340.12,
    y2: 272.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1437.12,
    y1: 29.22,
    x2: 1373.12,
    y2: 281.22,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1470.52,
    y1: 37.7,
    x2: 1406.52,
    y2: 289.7,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1135.29,397.65a44.09,44.09,0,1,0,44.09,44.09A44.09,44.09,0,0,0,1135.29,397.65Zm0,69.21a25.12,25.12,0,1,1,25.12-25.12A25.12,25.12,0,0,1,1135.29,466.86Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1141.05,
    y1: 405.47,
    x2: 1135,
    y2: 583.27,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.78,397.65a44.09,44.09,0,1,0,44.09,44.09A44.1,44.1,0,0,0,1242.78,397.65Zm0,69.21a25.12,25.12,0,1,1,25.12-25.12A25.11,25.11,0,0,1,1242.78,466.86Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1248.05,
    y1: 409.11,
    x2: 1242,
    y2: 586.91,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1350.26,397.65a44.09,44.09,0,1,0,44.1,44.09A44.09,44.09,0,0,0,1350.26,397.65Zm0,69.21a25.12,25.12,0,1,1,25.13-25.12A25.12,25.12,0,0,1,1350.26,466.86Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1356.25,
    y1: 412.79,
    x2: 1350.2,
    y2: 590.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1310.73,
    y1: 732.32,
    x2: 1382.48,
    y2: 732.32,
    gradientTransform: "translate(912.24 -737.7) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1395.46,
    y1: 687.13,
    x2: 1270.38,
    y2: 805.83,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1310.57,
    y1: 617.01,
    x2: 1382.33,
    y2: 617.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1387.18,
    y1: 579.04,
    x2: 1276.14,
    y2: 684.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1310.85,
    y1: 848.22,
    x2: 1382.61,
    y2: 848.22,
    gradientTransform: "translate(2024.04 -592.06) rotate(82.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1388.23,
    y1: 809.29,
    x2: 1277.19,
    y2: 914.67,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 846.49,
    y1: 531.11,
    x2: 989.9,
    y2: 531.11,
    gradientTransform: "translate(2.9 -4.98) rotate(0.31)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1048.19,
    y1: 468.21,
    x2: 1004.22,
    y2: 567.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1163.23,
    y1: 148.09,
    x2: 1534.84,
    y2: 148.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 168.99,
    y1: 225.16,
    x2: -189.04,
    y2: 1010.83,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 339.55,
    y1: 150.99,
    x2: 255.86,
    y2: 269.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 304.12,
    y1: 125.88,
    x2: 220.43,
    y2: 243.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 75.62,
    y1: 268.99,
    x2: 29.72,
    y2: 467.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -1224.92,
    y1: -1470.14,
    x2: -1306.34,
    y2: -1362.42,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, -218.14, 346.36)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1344.18,
    y1: -1384.83,
    x2: -1278.86,
    y2: -1451.84,
    gradientTransform: "matrix(-0.69, -0.73, -0.73, 0.69, -218.14, 346.36)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 36.96,
    y1: 314.44,
    x2: -58.05,
    y2: 489,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -52.82,
    y1: 581.03,
    x2: 36.27,
    y2: 581.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 1759.84, 0)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2039.29,745.2a104.84,104.84,0,0,0-22.7-36.62c-30.46-31.5-83.82-36.34-110.45-71.06-25-32.52-19.38-95.15-23.21-134.93-9.49-98.33-9.77-200.53-60.61-288.19-97.83-168.65-326.2-211.55-493.5-176.21C1154.71,75,1005,194.6,827.89,220.48c-72.68,10.62-150.09,3.83-216.79-31.26-89-46.83-160.39-117.64-265-113.46C177.4,82.52,45.62,142.75,8.07,335.54-18,469.43,22.43,553,81.64,666.33c38.43,73.52,40.71,165.27,17.75,244.61-10.35,35.79-22.4,60.6-23,99.95-1.33,85.54,18.06,138.25,73,200.23,47.59,53.65,109.4,96.32,175.11,123.21,118.61,48.55,251.37,53.27,377.2,30.59,159.21-28.69,312.1-99.82,473.77-99.82,146.09,0,285.61,58.18,429.65,83.1,73.26,12.67,165.45,18.1,226.52-33.56,48.75-41.24,25.28-117,51-170.1,28.38-58.66,80.82-100.71,114.75-155.64,25.21-40.82,39.51-87.89,47.27-135.5C2050.49,817.66,2051.63,778.15,2039.29,745.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2004.44,630.77c-26.36,113.39-211,766.56-953.25,697.53,0,0-6.89-462.36,938.47-709.41C1997.93,616.73,2006.16,623.36,2004.44,630.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1904.35,705.38c-24.2,32.72-49.74,64.32-75.85,95.48s-53.09,61.55-80.71,91.38a2346.67,2346.67,0,0,1-174.44,170.35q-46,40-94.35,77.36-48.63,36.9-99.78,70.33c-34.35,21.85-69.56,42.39-105.81,61a1033.65,1033.65,0,0,1-112.27,48.44,4.11,4.11,0,0,1-2.79-7.74h0l.06,0A1025.66,1025.66,0,0,0,1270,1264.5c36.08-18.34,71.18-38.58,105.46-60.15q51.07-32.91,99.67-69.53,48.33-36.9,94.41-76.65a2341.38,2341.38,0,0,0,174.87-169.11q41.57-44.46,81-90.84c26.2-31,51.9-62.43,76.15-94.89l0,0a1.74,1.74,0,1,1,2.79,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1653.53,15.43c43.14,128,259.25,881.34-517.48,1174.59,0,0-289.12-465.93,495.6-1179.42C1638.51,4.36,1650.71,7.07,1653.53,15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1599.62,139.9c-1.63,22.75-4,45.38-6.66,68s-5.71,45.17-9.07,67.69q-10,67.55-24,134.45c-18.6,89.13-42.16,177.32-72.35,263.31s-67,169.83-113.46,248.41a954,954,0,0,1-77.63,112.69c-14.39,17.73-29.35,35-45.22,51.49s-32.5,32.19-49.83,47.12a3.81,3.81,0,0,1-5-5.78h0l0,0q25.79-22,49.48-46.41c15.78-16.23,30.66-33.32,45-50.84a948.15,948.15,0,0,0,77.52-111.58c46.52-77.92,83.49-161.34,114-246.88s54.3-173.5,73.23-262.39q14.11-66.7,24.48-134.13,5.16-33.69,9.32-67.53c2.73-22.56,5.21-45.18,6.92-67.79v0a1.61,1.61,0,1,1,3.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M771.39,957.2S577.87,369.94,150.13,99.61A9.07,9.07,0,0,0,136.28,106C121.89,209.19,59.26,864.45,771.39,957.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M213.54,267.31c14.32,32.94,30,65.44,46.92,97.21q25,47.84,52.81,94.1c18.6,30.78,37.84,61.17,58.21,90.78,20.22,29.7,41.28,58.83,63.53,87s45,56,69.19,82.53c3,3.34,5.94,6.73,9,10l9.23,9.8c6.19,6.49,12.21,13.16,18.55,19.51l19,19.08,4.74,4.78,4.88,4.64,9.77,9.27c12.83,12.58,26.5,24.21,39.81,36.28,6.76,5.91,13.73,11.57,20.59,17.37l10.33,8.65c3.47,2.86,7.08,5.53,10.58,8.34l21.19,16.69,21.78,15.89,10.91,8,11.21,7.51L748.09,930l.06,0a2.54,2.54,0,0,1-2.7,4.29A1009.42,1009.42,0,0,1,570.39,805.75l-10.08-9.16-5-4.57-4.9-4.73-19.51-19c-6.49-6.34-12.67-13-19-19.47L502.37,739c-3.11-3.3-6.14-6.68-9.21-10-24.75-26.56-47.89-54.57-70.4-83a1515.79,1515.79,0,0,1-121-180.66q-27-47.18-50.5-96.22-11.7-24.53-22.42-49.49c-7.18-16.64-14-33.37-20.08-50.52a2.54,2.54,0,0,1,4.71-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M889.82,1314.53S495.38,759,117.08,780.52a10.44,10.44,0,0,0-9.39,13.39C130,868.91,274.81,1259.2,889.82,1314.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M208.94,861.71c24.94,21.6,50.71,42.38,76.64,62.88,13,10.19,26,20.37,39.17,30.42s26.33,20,39.66,29.77,26.68,19.54,40.12,29.17l40.57,28.52c27.34,18.59,54.67,37.2,82.51,55,27.53,18.32,55.89,35.32,83.93,52.83l42.76,25.11c7.14,4.16,14.23,8.41,21.42,12.49l21.71,12c14.5,7.94,28.91,16,43.47,23.86l44.1,22.68c7.35,3.77,14.64,7.67,22,11.34l22.37,10.69,44.74,21.38.07,0a2.42,2.42,0,0,1-2.06,4.39c-60.2-27.66-120-56.29-177.77-88.9l-21.8-11.92c-7.22-4.06-14.34-8.31-21.51-12.45l-43-25c-28.17-17.45-56.65-34.4-84.31-52.67q-83.5-53.91-163.19-113.47c-13.32-9.84-26.41-20-39.63-30s-26.12-20.38-39.13-30.64c-25.79-20.81-51.31-41.9-76.17-63.91a2.43,2.43,0,0,1,3.19-3.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1031.81,
    cy: 748.57,
    rx: 590.29,
    ry: 637.16,
    transform: "translate(238.71 1746.56) rotate(-87.49)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1194.59,751.42c-.16,104.11-7.29,208.43-25.64,311.07-4.65,25.64-10,51.15-16.45,76.43a734.84,734.84,0,0,1-23,74.79c-9.17,24.42-19.82,48.49-34.26,70.49-7.27,10.92-15.53,21.38-25.71,30a73.18,73.18,0,0,1-16.83,10.85,50.4,50.4,0,0,1-19.65,4.63,49.51,49.51,0,0,1-19.86-3.66A68.55,68.55,0,0,1,996,1315.76c-10.42-8.34-18.86-18.68-26.26-29.52C955,1264.4,944.25,1240.38,935,1216a719.36,719.36,0,0,1-23.2-74.71c-6.48-25.26-11.92-50.76-16.61-76.39-9.34-51.27-15.72-103-20-154.94s-6.41-104-6.67-156.09c-.13-26,.58-52.07,1.5-78.09s2.41-52,4.33-78c3.85-51.93,9.6-103.75,18.15-155.14,4.3-25.68,9.3-51.26,15.32-76.62a734.87,734.87,0,0,1,21.74-75.08c4.37-12.29,9.15-24.45,14.6-36.32a265.43,265.43,0,0,1,18.7-34.45c7.17-10.93,15.42-21.36,25.69-29.71a65.66,65.66,0,0,1,17-10.18,48,48,0,0,1,19.54-3.47,51.87,51.87,0,0,1,19.3,4.53,75.46,75.46,0,0,1,16.77,10.46c10.25,8.33,18.73,18.51,26.25,29.2,15,21.53,26.23,45.27,36,69.43A713,713,0,0,1,1148,364.6c7,25.12,12.83,50.52,17.92,76.07C1186.1,543,1194.29,647.29,1194.59,751.42Zm-7.71,0c.1-51.88-1.87-103.77-6.19-155.46a1495,1495,0,0,0-20.28-154.22c-4.79-25.48-10.37-50.82-17-75.88a707.61,707.61,0,0,0-23.71-74c-9.43-24.08-20.36-47.74-34.87-69.11-7.29-10.61-15.52-20.69-25.4-28.89a72.82,72.82,0,0,0-16.08-10.3,48.36,48.36,0,0,0-18.38-4.48,45.16,45.16,0,0,0-18.53,3.49,63.12,63.12,0,0,0-16.22,10c-9.85,8.18-17.83,18.48-24.77,29.31a261.69,261.69,0,0,0-18.09,34.22c-5.26,11.81-9.87,23.92-14.08,36.16a729.87,729.87,0,0,0-20.79,74.87c-5.72,25.29-10.42,50.81-14.41,76.44-8,51.26-13.13,103-16.4,154.73S877.22,702,877.32,753.85q-.21,77.82,5.45,155.5c3.88,51.72,9.84,103.32,18.74,154.41,4.47,25.53,9.68,50.94,15.93,76.09a716.72,716.72,0,0,0,22.45,74.31c9,24.21,19.5,48,33.7,69.49,7.14,10.64,15.27,20.73,25.13,28.72a64.39,64.39,0,0,0,16.08,9.76,44.28,44.28,0,0,0,18.18,3.46,46.16,46.16,0,0,0,18-4.41,69,69,0,0,0,15.75-10.34c9.64-8.27,17.6-18.49,24.62-29.22,14-21.62,24.31-45.5,33.19-69.75a728.41,728.41,0,0,0,22.19-74.4c6.18-25.16,11.33-50.58,15.75-76.12,8.85-51.1,14.72-102.7,18.63-154.42S1186.9,803.3,1186.88,751.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1457.23,751.42c-.36,67-9,134.12-26.93,198.77-18.26,64.51-45.78,126.56-83.16,182.28a524.49,524.49,0,0,1-63.52,77.78,445.31,445.31,0,0,1-78.19,63,376.46,376.46,0,0,1-91.23,41.71,341.19,341.19,0,0,1-198.37.09,377.1,377.1,0,0,1-91.3-41.65,446.47,446.47,0,0,1-78.3-62.89,525.72,525.72,0,0,1-63.64-77.77c-37.45-55.72-65-117.81-83.38-182.35A722.35,722.35,0,0,1,579,851.79a740.91,740.91,0,0,1,.06-200.74,722.13,722.13,0,0,1,20.26-98.52c18.39-64.51,46-126.56,83.49-182.22a525.28,525.28,0,0,1,63.65-77.68,444.71,444.71,0,0,1,78.27-62.79A379.08,379.08,0,0,1,916,188.35a338.75,338.75,0,0,1,198.07.08A378.12,378.12,0,0,1,1205.21,230a443.9,443.9,0,0,1,78.16,62.83,524.54,524.54,0,0,1,63.53,77.7c37.4,55.65,65,117.67,83.27,182.15C1448.16,617.31,1456.82,684.37,1457.23,751.42Zm-8.83,0c-.1-66.29-8.36-132.64-25.85-196.63s-44.06-125.56-80.52-181A519.65,519.65,0,0,0,1280,296.21a433.94,433.94,0,0,0-76.8-63,370.93,370.93,0,0,0-90.06-41.63,330.45,330.45,0,0,0-196.09.08,370.6,370.6,0,0,0-90,41.71c-28,17.84-53.54,39.3-76.69,63a520,520,0,0,0-62,77.57c-36.38,55.46-62.8,117.11-80.3,181a726.79,726.79,0,0,0-19.31,97.39,757.74,757.74,0,0,0,.07,198.15,725,725,0,0,0,19.37,97.36c17.55,63.83,44,125.44,80.42,180.84a518.81,518.81,0,0,0,62,77.49c23.15,23.67,48.7,45.11,76.67,62.9a372.31,372.31,0,0,0,89.92,41.55,328.06,328.06,0,0,0,195.78.09,372.46,372.46,0,0,0,90-41.49c28-17.77,53.59-39.19,76.77-62.85a519.62,519.62,0,0,0,62.09-77.47c36.48-55.41,63-117,80.63-180.91S1448.25,817.7,1448.4,751.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M499,522.59l132.79-1.07,132.8-.61,265.6-.49,265.6.54,132.8.67,132.79,1.15a.4.4,0,0,1,.39.4.38.38,0,0,1-.39.38l-132.79,1.16-132.8.67-265.6.54-265.6-.49-132.8-.61L499,523.76a.6.6,0,0,1-.58-.59A.59.59,0,0,1,499,522.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M653.08,300.17c31.43-.5,62.85-.71,94.28-1.08l94.28-.6c31.43-.26,62.86-.23,94.29-.31l94.28-.18,188.57.54,94.28.66c31.43.39,62.85.62,94.28,1.16a.39.39,0,0,1,.39.4.4.4,0,0,1-.39.38c-31.43.53-62.85.76-94.28,1.16l-94.28.66-188.57.54-94.28-.18c-31.43-.08-62.86-.05-94.29-.31l-94.28-.61c-31.43-.36-62.85-.57-94.28-1.07a.58.58,0,0,1-.57-.59A.57.57,0,0,1,653.08,300.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M452.87,745,597.2,744l144.34-.61,288.67-.49,288.67.54,144.34.66,144.33,1.16a.39.39,0,0,1,0,.78l-144.33,1.16-144.34.66-288.67.54-288.67-.49-144.34-.61-144.33-1.07a.58.58,0,0,1,0-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M499,967.45l132.79-1.08,132.8-.61,265.6-.49,265.6.54,132.8.67,132.79,1.16a.38.38,0,0,1,.39.39.4.4,0,0,1-.39.39l-132.79,1.15-132.8.67-265.6.54-265.6-.49-132.8-.61L499,968.61a.6.6,0,0,1-.58-.59A.57.57,0,0,1,499,967.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1426.34,1192.49H672.08a2,2,0,0,1,0-4.07h754.26a2,2,0,1,1,0,4.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1833.37,800.08a.94.94,0,0,1-.55-.17,1,1,0,0,1-.23-1.34c.72-1,1.42-2.07,2.08-3.14a1,1,0,0,1,1.32-.31,1,1,0,0,1,.31,1.32c-.68,1.1-1.4,2.19-2.15,3.24A1,1,0,0,1,1833.37,800.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1784.47,826.48a1,1,0,0,1-1-.93.94.94,0,0,1,.92-1,61.65,61.65,0,0,0,7.17-.67,1,1,0,0,1,.28,1.9,62.86,62.86,0,0,1-7.38.68Zm-11.83-.72h-.15a65.9,65.9,0,0,1-7.25-1.58,1,1,0,1,1,.51-1.84,62.4,62.4,0,0,0,7,1.52,1,1,0,0,1,.8,1.1A1,1,0,0,1,1772.64,825.76Zm30.62-2.84a1,1,0,0,1-.32-1.86,61.12,61.12,0,0,0,6.62-2.81,1,1,0,0,1,.85,1.72,62.94,62.94,0,0,1-6.83,2.89A1,1,0,0,1,1803.26,822.92Zm-48.84-3a.92.92,0,0,1-.42-.1,61.85,61.85,0,0,1-6.43-3.69,1,1,0,1,1,1-1.6,62.14,62.14,0,0,0,6.24,3.58,1,1,0,0,1-.43,1.81Zm65.65-6.13a1,1,0,0,1-.58-1.72l.68-.52c1.67-1.3,3.28-2.7,4.8-4.15a1,1,0,0,1,1.35,0,1,1,0,0,1,0,1.36,63.14,63.14,0,0,1-4.94,4.28l-.7.54A1,1,0,0,1,1820.07,813.82Zm-81.24-4.92a.93.93,0,0,1-.66-.27,63.44,63.44,0,0,1-5-5.47,1,1,0,0,1,1.48-1.21,62.82,62.82,0,0,0,4.86,5.31,1,1,0,0,1,0,1.35A.94.94,0,0,1,1738.83,808.9Zm-11.53-15.24a1,1,0,0,1-.84-.51,64.1,64.1,0,0,1-3.14-6.72,1,1,0,0,1,.54-1.24,1,1,0,0,1,1.24.53,60.3,60.3,0,0,0,3,6.52,1,1,0,0,1-.84,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1720.91,775.6a1,1,0,0,1-.94-.78c-.24-1.26-.44-2.55-.6-3.84a1,1,0,0,1,1.9-.23c.16,1.24.35,2.49.58,3.72a1,1,0,0,1-.76,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1831.92,775.25l-7.41-6.27a42.42,42.42,0,0,0-.31-13.71l7.12-6.61a.78.78,0,0,0,.19-.9l-4.71-10.67a.78.78,0,0,0-.79-.47l-9.68.81a42.21,42.21,0,0,0-9.92-9.47l.37-9.71a.8.8,0,0,0-.51-.78l-10.86-4.21a.81.81,0,0,0-.9.23l-6.28,7.42a42.14,42.14,0,0,0-13.71.3l-6.6-7.12a.8.8,0,0,0-.9-.19l-10.67,4.71a.78.78,0,0,0-.47.79l.81,9.68a42.21,42.21,0,0,0-9.47,9.92l-9.71-.37a.81.81,0,0,0-.78.51L1732.52,750a.81.81,0,0,0,.23.9l7.42,6.28a42.14,42.14,0,0,0,.3,13.71l-7.12,6.6a.81.81,0,0,0-.19.91l4.71,10.66a.78.78,0,0,0,.79.47l9.68-.81a42.21,42.21,0,0,0,9.92,9.47l-.37,9.71a.8.8,0,0,0,.51.78l10.86,4.21a.79.79,0,0,0,.9-.23l6.28-7.41a42.42,42.42,0,0,0,13.71-.31l6.6,7.12a.78.78,0,0,0,.9.19l10.67-4.7a.8.8,0,0,0,.47-.8l-.81-9.68a42.21,42.21,0,0,0,9.47-9.92l9.71.37a.8.8,0,0,0,.78-.51l4.21-10.86A.79.79,0,0,0,1831.92,775.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1782.35,774.38a11.3,11.3,0,1,1,6.94-2.39A11.31,11.31,0,0,1,1782.35,774.38Zm0-20.7a9.3,9.3,0,0,0-5.76,2,9.38,9.38,0,1,0,6.93-1.92C1783.09,753.71,1782.7,753.68,1782.32,753.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1732.13,726.8a.93.93,0,0,1-.57-.19,1,1,0,0,1-.2-1.34c.77-1,1.58-2.06,2.41-3a1,1,0,0,1,1.47,1.23c-.81.95-1.59,1.95-2.34,2.95A1,1,0,0,1,1732.13,726.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1841.5,743.93a1,1,0,0,1-.91-.64,59.22,59.22,0,0,0-2.66-6.56,1,1,0,0,1,.46-1.28,1,1,0,0,1,1.27.46,62.94,62.94,0,0,1,2.75,6.76,1,1,0,0,1-.6,1.21A.84.84,0,0,1,1841.5,743.93Zm-8.67-16.68a1,1,0,0,1-.78-.39c-.4-.55-.81-1.1-1.23-1.63-1-1.33-2.13-2.62-3.26-3.85a1,1,0,0,1,1.41-1.3c1.17,1.27,2.3,2.6,3.36,4,.44.55.86,1.11,1.27,1.68a1,1,0,0,1-.21,1.33A.92.92,0,0,1,1832.83,727.25Zm-90-11.63a1,1,0,0,1-.6-1.7c.35-.29.71-.57,1.07-.85,1.55-1.22,3.18-2.37,4.83-3.43a1,1,0,1,1,1,1.61c-1.61,1-3.19,2.15-4.7,3.33l-1,.82A.91.91,0,0,1,1742.83,715.62Zm76.77-1.74a1,1,0,0,1-.57-.19,59.63,59.63,0,0,0-5.91-3.89,1,1,0,1,1,1-1.66,65.27,65.27,0,0,1,6.09,4,1,1,0,0,1,.2,1.34A1,1,0,0,1,1819.6,713.88ZM1759,706.05a1,1,0,0,1-.36-1.85,62.5,62.5,0,0,1,6.92-2.33,1,1,0,0,1,.5,1.85,61.34,61.34,0,0,0-6.7,2.26A1.15,1.15,0,0,1,1759,706.05Zm44-1a.87.87,0,0,1-.32-.06,64.3,64.3,0,0,0-6.8-2,1,1,0,1,1,.42-1.86,63,63,0,0,1,7,2,1,1,0,0,1-.31,1.86Zm-25.67-3.32a1,1,0,0,1-.08-1.91c1.66-.14,3.35-.2,5-.2h0c.76,0,1.51,0,2.27,0a1,1,0,0,1,.92,1,1,1,0,0,1-1,.92c-.74,0-1.5-.05-2.22,0-1.61,0-3.25.07-4.86.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1844.61,759.13a1,1,0,0,1-.95-.89c-.1-1.25-.23-2.51-.4-3.74a1,1,0,1,1,1.89-.27c.18,1.28.32,2.58.42,3.86a1,1,0,0,1-.88,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1782.14,792.08a29.08,29.08,0,1,1,26.56-40.81q.43,1,.78,2a28.59,28.59,0,0,1,1,3.47c0,.16.07.32.1.48a1.23,1.23,0,0,1,0,.19,1,1,0,0,1-1.89.19A27.21,27.21,0,0,0,1807,752h0a27.19,27.19,0,0,0-35.29-14.12l-.28.12-.25.11a27.17,27.17,0,1,0,33.14,40.56,1,1,0,0,1,1.33-.23,1,1,0,0,1,.41.78,1,1,0,0,1-.18.56,29.1,29.1,0,0,1-23.69,12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M185.36,818.57,297.28,1100A33.33,33.33,0,0,0,333,1120.71l293.48-20.53L520.78,799.74a18.69,18.69,0,0,0-17.91-12C451.42,788.87,264,793.5,197,799.47A13.89,13.89,0,0,0,185.36,818.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.12,1107.94,237.3,824a8.86,8.86,0,0,1,8-12.1l276.38-10.49A16.77,16.77,0,0,1,538,812l101.22,276.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M736.29,1109.4c0,3.15-4.26,5.7-9.5,5.7h-386c-8,0-14.43-3.88-14.43-8.67l-6.07-4.24,400.77-2.06c8.44.07,15.22,4.2,15.22,9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M636.18,831.89c-8.4-13.88-23.06-23-31.9-36.59-11.14-17.14-11.52-39.82-4.22-58.91,6.05-15.84,16.84-29.52,23-45.31,8.31-21.25,8.47-30.39,4.68-51.73-3.33-18.8-10.64-38.81-28.68-49.59-22.31-13.33-49.61-15.86-75.15-11-26.51,5-52.22,16.27-71.61,35s-32,45.07-31.72,72c.22,18.25,6.09,37.07.24,54.36a42.74,42.74,0,0,1-30.19,27.4c-15.37,3.59-31.33-1.66-47.11-1.46a68.67,68.67,0,0,0-43.07,16.11c-10.57,8.95-18.41,21.5-20.19,35.24s3,28.51,13.56,37.48c7.22,6.13,17.38,10.28,20.05,19.37,3,10.17-5.77,20.39-15.53,24.52S277.6,903.3,267.67,907c-22.22,8.27-35.69,33.31-34,57S250.41,1009,270,1022.33s43.43,19.29,67.06,21.22,47.39,0,71.07-1.07c27.1-1.28,54.73-1.64,80.42-10.33,26-8.79,48.43-25.6,69.36-43.32,9.91-8.4,20-17.58,24.41-29.78,3.23-8.86,3.24-18.7,7-27.36,8-18.6,30.07-26.51,42.85-42.19C645.13,873.59,646.81,849.44,636.18,831.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.25,865.31h-.15A33.43,33.43,0,0,1,321.67,812c10.33-13.4,28.51-16.87,46.24-19.28l32.14-4.36c18.14-2.45,36.72-6,47.15-19.38,11.13-14.3,8.91-33.83,6.76-52.72-.25-2.16-.49-4.31-.71-6.42-2.81-27,0-50.45,8.39-69.73,10.23-23.52,29.3-40.83,51-46.29a.81.81,0,0,1,1,.59.82.82,0,0,1-.6,1c-21.22,5.34-39.87,22.3-49.89,45.36-8.27,19-11,42.21-8.27,68.9q.33,3.18.71,6.42c2.18,19.21,4.44,39.08-7.1,53.91-10.81,13.89-29.75,17.5-48.22,20l-32.14,4.36c-17.39,2.35-35.21,5.74-45.16,18.65a31.78,31.78,0,0,0,19.43,50.66.82.82,0,0,1-.15,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.39,855.45a1.67,1.67,0,0,1-1.12-.44c-3.93-3.69-8.38-7.86-11-13.15-2.4-4.8-3.6-11.93.24-17.54,2.5-3.66,6.59-5.75,10.64-7.47A132.49,132.49,0,0,1,381.79,808c6.85-1.12,13.87-1.7,20.65-2.27,8.76-.73,17.81-1.48,26.48-3.4,10.36-2.28,28.95-8.55,37-24.83,6.54-13.15,4.11-27.82,1.54-43.35-2.08-12.59-4.24-25.61-1.28-38a1.63,1.63,0,1,1,3.18.76c-2.8,11.73-.7,24.42,1.33,36.69,2.54,15.36,5.17,31.24-1.84,45.34-8.69,17.5-28.33,24.16-39.26,26.57-8.89,2-18.05,2.73-26.92,3.46-6.72.56-13.67,1.14-20.39,2.24a129.75,129.75,0,0,0-29.91,8.66c-3.34,1.42-7.09,3.2-9.22,6.31-2.5,3.65-2.51,9.24,0,14.23,2.38,4.76,6.42,8.55,10.33,12.21a1.64,1.64,0,0,1,.08,2.32A1.67,1.67,0,0,1,352.39,855.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M612.77,800.25c-15.3-4.86-59.93-14.09-103.15,24.52a26.37,26.37,0,0,0-8,26.16c10.76,42.29,32.59,177.73,5.26,231.14,0,0,8.56-.08,103.69,1,0,0,24.42-99.12,55-142.31C686.7,911,634.48,827,621.26,806.73A15.82,15.82,0,0,0,612.77,800.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M571.66,715.9s-23.77,64-25.94,92.31a48.66,48.66,0,0,0,48.94-7.07s3.52-64.21,7.3-75.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M604.66,628.71s58.14,84.19,22.2,107.8-77.33-36.23-77.33-36.23-13.07-45.78,1.61-61S604.66,628.71,604.66,628.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M577.45,608.37s27.22,6.92,30.85,19.34-39.13,23.21-51.07,23.58L546.82,701s-27.67-47.39-16-74.31S577.45,608.37,577.45,608.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M561.15,694.34s-22.71-27.19-32.2-9.85,20.34,30.93,30.88,22.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M503.39,833.08s-73.62,59.2-93,141.41,104.69,93,104.69,93,17.16-18.56,37.07-11.52,2.08-32.83-21.34-33.11-12.87,18.42-45.76,2.88c-32-15.13-51.25-60.66,32.19-127.87a37.12,37.12,0,0,0,11.11-14.63C545,843.21,532.75,816.62,503.39,833.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M964.91,858.61H949.7c-2.69,0-4.88-1.29-4.94-2.91l-4.65-103.53c-.06-1.67,2.17-3,4.94-3h19.86c2.73,0,4.94,1.33,4.94,3V855.63C969.85,857.27,967.64,858.61,964.91,858.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M939.22,740.94l.18,1.36c.16,1.29,1.89,2.31,4,2.37l21.92.68c2.44.08,4.49-1.09,4.49-2.57v-2.06c0-1.38-1.8-2.51-4.09-2.57-5.46-.14-15.3-.31-22.59,0C940.81,738.28,939,739.52,939.22,740.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M923.4,858.61H908.19c-2.68,0-4.88-1.29-4.94-2.91l-4.64-115.32c-.07-1.67,2.16-3,4.94-3H923.4c2.73,0,4.94,1.33,4.94,3V855.63C928.34,857.27,926.13,858.61,923.4,858.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M897.72,729.15l.17,1.37c.17,1.28,1.9,2.3,4,2.37l21.93.67c2.44.08,4.48-1.09,4.48-2.56v-2.07c0-1.37-1.8-2.51-4.08-2.56-5.47-.15-15.31-.32-22.6,0C899.31,726.5,897.54,727.73,897.72,729.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1006.67,858.61H991.46c-2.69,0-4.88-1.29-4.94-2.91l-1.79-73.54c-.07-1.67,2.17-3,4.94-3h19.86c2.72,0,4.94,1.33,4.94,3l-2.86,73.54C1011.61,857.27,1009.4,858.61,1006.67,858.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M983.84,770.93l.18,1.36c.16,1.29,1.89,2.31,4,2.37l21.93.68c2.44.08,4.49-1.09,4.49-2.57v-2.06c0-1.38-1.8-2.51-4.09-2.57-5.46-.14-15.3-.31-22.59,0C985.43,768.28,983.66,769.51,983.84,770.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M843,858.61H827.77c-2.68,0-4.87-1.29-4.93-2.91l-4.65-103.53c-.06-1.67,2.17-3,4.94-3H843c2.73,0,4.94,1.33,4.94,3V855.63C847.93,857.27,845.72,858.61,843,858.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M817.3,740.94l.18,1.36c.16,1.29,1.89,2.31,4,2.37l21.93.68c2.44.08,4.49-1.09,4.49-2.57v-2.06c0-1.38-1.8-2.51-4.09-2.57-5.46-.14-15.3-.31-22.59,0C818.89,738.28,817.12,739.52,817.3,740.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M884.75,858.61H869.54c-2.69,0-4.88-1.29-4.94-2.91l-1.79-73.54c-.07-1.67,2.16-3,4.94-3H887.6c2.73,0,4.95,1.33,4.95,3l-2.86,73.54C889.69,857.27,887.48,858.61,884.75,858.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M861.92,770.93l.18,1.36c.16,1.29,1.89,2.31,4,2.37l21.93.68c2.44.08,4.49-1.09,4.49-2.57v-2.06c0-1.38-1.81-2.51-4.09-2.57-5.46-.14-15.3-.31-22.59,0C863.51,768.28,861.74,769.51,861.92,770.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1086.83,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1117.16,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1147.48,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1177.81,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1208.14,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1238.46,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1268.79,
    y: 545.91,
    width: 18.15,
    height: 320.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1086.83,
    y: 698.51,
    width: 18.15,
    height: 167.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1117.16,
    y: 756.09,
    width: 18.15,
    height: 109.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1147.48,
    y: 613.78,
    width: 18.15,
    height: 252.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1177.81,
    y: 805.44,
    width: 18.15,
    height: 60.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1208.14,
    y: 647.51,
    width: 18.15,
    height: 218.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1238.46,
    y: 685.34,
    width: 18.15,
    height: 180.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1268.79,
    y: 726.47,
    width: 18.15,
    height: 139.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1135.29,397.65a44.09,44.09,0,1,0,44.09,44.09A44.09,44.09,0,0,0,1135.29,397.65Zm0,69.21a25.12,25.12,0,1,1,25.12-25.12A25.12,25.12,0,0,1,1135.29,466.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1073.72,
    y: 432.04,
    width: 130.98,
    height: 55.43
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1242.78,397.65a44.09,44.09,0,1,0,44.09,44.09A44.1,44.1,0,0,0,1242.78,397.65Zm0,69.21a25.12,25.12,0,1,1,25.12-25.12A25.11,25.11,0,0,1,1242.78,466.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1181.2,
    y: 410.62,
    width: 130.98,
    height: 76.85
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1350.26,397.65a44.09,44.09,0,1,0,44.1,44.09A44.09,44.09,0,0,0,1350.26,397.65Zm0,69.21a25.12,25.12,0,1,1,25.13-25.12A25.12,25.12,0,0,1,1350.26,466.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1288.69,
    y: 459.76,
    width: 130.98,
    height: 27.71
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 1346.6,
    cy: 732.32,
    r: 35.88,
    transform: "translate(-123.42 1166.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1367.92,724.74a23,23,0,1,1-21.32-14.29l1.17,0v-5.84l-1.17,0a28.88,28.88,0,1,0,26.68,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1376.09,783.39h-58.46a6.65,6.65,0,1,0,0,13.29h58.46a6.65,6.65,0,1,0,0-13.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 1346.45,
    cy: 617.01,
    r: 35.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1358.64,637.68a23,23,0,1,1-12.27-42.54c.39,0,.77,0,1.16,0v-5.84c-.39,0-.77,0-1.16,0a28.89,28.89,0,1,0,15.17,53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1376.25,668.08h-58.47a6.65,6.65,0,0,0,0,13.29h58.47a6.65,6.65,0,0,0,0-13.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 1346.73,
    cy: 848.22,
    r: 35.88,
    transform: "translate(340.32 2081.22) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1366.27,861.17a23,23,0,1,1-19.06-36c.39,0,.78,0,1.16,0v-5.84l-1.16,0A28.88,28.88,0,1,0,1371,864.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1317.5,911.41H1376a6.65,6.65,0,1,0,0-13.29H1317.5a6.65,6.65,0,1,0,0,13.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 916.35,
    cy: 529.26,
    r: 84.73,
    transform: "translate(312.91 1398.55) rotate(-85.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M838.25,526.07h0a1,1,0,0,1-.91-1,78.77,78.77,0,0,1,1.15-9.94,1,1,0,1,1,1.88.33,79.08,79.08,0,0,0-1.12,9.71A1,1,0,0,1,838.25,526.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M846.48,495a1,1,0,0,1-.85-1.39,79.26,79.26,0,0,1,85-42.25,1,1,0,1,1-.34,1.88A78.21,78.21,0,0,0,916.35,452a76.93,76.93,0,0,0-69,42.49A1,1,0,0,1,846.48,495Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 918.19,
    cy: 531.11,
    r: 71.71,
    transform: "translate(-2.87 4.99) rotate(-0.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M940.15,504c0,12.14-9.84,25.25-22,25.25s-22-13.11-22-25.25,9.84-20.76,22-20.76S940.15,491.87,940.15,504Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M890.88,576h53.67a13,13,0,0,0,12.37-9l2.89-9A13,13,0,0,0,952,541.8c-21.84-8-44.43-7-67.56.74a12.94,12.94,0,0,0-8.29,15.68l2.22,8.2A13,13,0,0,0,890.88,576Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M916.35,674.08c-79.86,0-144.82-65-144.82-144.82s65-144.82,144.82-144.82,144.82,65,144.82,144.82S996.2,674.08,916.35,674.08Zm0-244.23a99.41,99.41,0,1,0,99.4,99.41A99.53,99.53,0,0,0,916.35,429.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1060.77,518.42l-45.29,3.4q.27,3.69.27,7.44a98.88,98.88,0,0,1-5.9,33.75l42.72,15.42a144.2,144.2,0,0,0,8.6-49.17C1061.17,525.61,1061,522,1060.77,518.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M916.35,628.66a99.41,99.41,0,1,1,24.22-195.82l11.06-44a144.59,144.59,0,0,0-35.28-4.35c-79.86,0-144.82,65-144.82,144.82s65,144.82,144.82,144.82c62.6,0,116-39.92,136.22-95.65L1009.85,563A99.57,99.57,0,0,1,916.35,628.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1015.48,521.82l45.29-3.4a144,144,0,0,0-14.24-52.58l-40.83,19.89A98.81,98.81,0,0,1,1015.48,521.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1094.7,935.77l172.38-1a9,9,0,0,1,7.8,13.71L1274,950a9,9,0,0,1-7.76,4.39H1094.75a9,9,0,0,1-9-9.05v-.48A9.06,9.06,0,0,1,1094.7,935.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1070.62,945v.28a9,9,0,0,1-9,9.05H1023.3a9.05,9.05,0,0,1-8.74-6.71h0a9,9,0,0,1,8.68-11.38l38.26-.28A9,9,0,0,1,1070.62,945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1136.16,968.25l130.92-1a9,9,0,0,1,7.8,13.71l-.86,1.44a9,9,0,0,1-7.76,4.39h-130a9,9,0,0,1-9-9.05v-.48A9.05,9.05,0,0,1,1136.16,968.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1112.08,977.5v.28a9,9,0,0,1-9,9.05h-38.27a9,9,0,0,1-8.74-6.71h0a9,9,0,0,1,8.67-11.38l38.27-.28A9,9,0,0,1,1112.08,977.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1906.24,349.14l-106.55,268a31.74,31.74,0,0,1-34,19.69l-279.41-19.55,100.64-286a17.79,17.79,0,0,1,17-11.47c49,1.13,227.42,5.53,291.25,11.21A13.22,13.22,0,0,1,1906.24,349.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1775.09,624.64l106.46-270.38a8.43,8.43,0,0,0-7.66-11.52l-263.13-10a16,16,0,0,0-15.46,10.12l-96.37,263.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1391.25,628.08a9,9,0,0,0,9,9h367.48a13.75,13.75,0,0,0,13.75-13.75l5.78-6.71-381.57-3.27a14.68,14.68,0,0,0-14.48,14.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1858.69,450.86a1,1,0,0,1-.42-.08,1.13,1.13,0,0,1-.63-1.47l39.24-98.13a11,11,0,0,0-9.7-15.08L1816,332.76a1.13,1.13,0,1,1,.11-2.26l71.15,3.34A13.26,13.26,0,0,1,1899,352l-39.24,98.14A1.12,1.12,0,0,1,1858.69,450.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1104.92,397.82,1362.56,375a20.32,20.32,0,0,0,18.52-20.13l1-173.72a20.32,20.32,0,0,0-21.73-20.38L1086,179.82a20.32,20.32,0,0,0-18.83,22.07l15.75,177.49A20.31,20.31,0,0,0,1104.92,397.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1366.93,197.93l1.7,150a12.57,12.57,0,0,1-11.32,12.65l-247,24.53a12.56,12.56,0,0,1-13.76-11.39l-14.24-160.38a12.58,12.58,0,0,1,11.84-13.66l259.57-14.15A12.57,12.57,0,0,1,1366.93,197.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1249.81,329,1110,337.18a2.55,2.55,0,0,0-2.39,2.76l.2,2.25a2.56,2.56,0,0,0,2.73,2.31l139.61-10.45a2.55,2.55,0,0,0,2.35-2.76h0A2.55,2.55,0,0,0,1249.81,329Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1253.53,343l.09,1a2.55,2.55,0,0,1-2.31,2.76l-139.44,12.37a2.54,2.54,0,0,1-2.76-2.31l-.09-1a2.55,2.55,0,0,1,2.31-2.76l139.44-12.37A2.54,2.54,0,0,1,1253.53,343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1212.32,359.24l0,.42a2.55,2.55,0,0,1-2.31,2.76L1112.93,371a2.55,2.55,0,0,1-2.76-2.32l-.18-2a2.55,2.55,0,0,1,2.35-2.76l97.26-7.07A2.54,2.54,0,0,1,1212.32,359.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1126.52,335.77l304-6.19a23.9,23.9,0,0,0,23.34-22.13l15-203.7a23.9,23.9,0,0,0-23.87-25.65l-323.33.42a23.89,23.89,0,0,0-23.86,24.39l4.26,209.45A23.9,23.9,0,0,0,1126.52,335.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1449.87,122.27l-10,176.07a14.77,14.77,0,0,1-14.3,13.93l-291.76,9a14.77,14.77,0,0,1-15.23-14.47l-3.85-189.26a14.78,14.78,0,0,1,15-15.08l305.62,4.19A14.78,14.78,0,0,1,1449.87,122.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1302,266.6,1137.34,265a3,3,0,0,0-3,3.06l.06,2.65a3,3,0,0,0,3,2.93L1302,272.59a3,3,0,0,0,3-3h0A3,3,0,0,0,1302,266.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1305.24,283.33l0,1.13a3,3,0,0,1-2.94,3.06l-164.56,3.35a3,3,0,0,1-3-2.94l0-1.13a3,3,0,0,1,2.93-3.05l164.56-3.35A3,3,0,0,1,1305.24,283.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1255.59,299.1v.5a3,3,0,0,1-2.93,3L1138.06,305a3,3,0,0,1-3-2.93l0-2.33a3,3,0,0,1,3-3.05l114.65-.5A3,3,0,0,1,1255.59,299.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1171.39,285.38H1508.7a26.51,26.51,0,0,0,26.39-24l21.26-225.54a26.52,26.52,0,0,0-25.89-29L1171.89,0a26.51,26.51,0,0,0-27,26.5V258.88A26.51,26.51,0,0,0,1171.39,285.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1534.79,55.92l-15.08,195a16.4,16.4,0,0,1-16.17,15.13l-323.75,3.39a16.39,16.39,0,0,1-16.56-16.39v-210a16.39,16.39,0,0,1,17-16.38L1519,38.27A16.4,16.4,0,0,1,1534.79,55.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1362,54.14l-182.56-5.46A3.31,3.31,0,0,0,1176,52v2.94a3.31,3.31,0,0,0,3.27,3.32l182.56,2.52a3.31,3.31,0,0,0,3.37-3.31h0A3.32,3.32,0,0,0,1362,54.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1175.97,
    y: 69.44,
    width: 189.2,
    height: 7.89,
    rx: 3.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1309.76,89.13v.55a3.32,3.32,0,0,1-3.32,3.32H1179.29a3.32,3.32,0,0,1-3.32-3.32V87.09a3.32,3.32,0,0,1,3.37-3.32l127.15,2A3.33,3.33,0,0,1,1309.76,89.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1224.37,189.34a1.38,1.38,0,0,0,.9-.32l54.8-44.52,54,39.57a1.44,1.44,0,0,0,2-.24l75.15-90.15c8.54,7.49,63.91,56,71.28,62.48a1.44,1.44,0,0,0,1.89-2.16c-8-7-72.39-63.45-72.39-63.45a1.44,1.44,0,0,0-1-.35,1.4,1.4,0,0,0-1,.51L1334.71,181l-53.83-39.43a1.44,1.44,0,0,0-1.76.05L1224.4,186l-29.3-25.61a1.44,1.44,0,1,0-1.89,2.17l30.21,26.4A1.42,1.42,0,0,0,1224.37,189.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1409,236.86V234a1,1,0,0,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.57v-2.87a1,1,0,0,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.56v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,0,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,0,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0V189a1,1,0,1,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.57V167a1,1,0,0,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.57v-2.87a1,1,0,0,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.56v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,0,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,0,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0v2.87a1,1,0,1,1-1.92,0Zm0-9.57v-2.87a1,1,0,1,1,1.92,0V122a1,1,0,1,1-1.92,0Zm0-9.57V109.6a1,1,0,1,1,1.92,0v2.87a1,1,0,1,1-1.92,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1334,238.62v-2.87a1,1,0,0,1,1.91,0v2.87a1,1,0,1,1-1.91,0Zm0-9.57v-2.87a1,1,0,0,1,1.91,0v2.87a1,1,0,1,1-1.91,0Zm0-9.56v-2.87a1,1,0,1,1,1.91,0v2.87a1,1,0,0,1-1.91,0Zm0-9.57v-2.87a1,1,0,1,1,1.91,0v2.87a1,1,0,0,1-1.91,0Zm0-9.57v-2.87a1,1,0,1,1,1.91,0v2.87a1,1,0,1,1-1.91,0Zm0-9.57v-2.87a1,1,0,1,1,1.91,0v2.87a1,1,0,1,1-1.91,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1278,241.42a1,1,0,0,1-.92-1l.09-2.87a.92.92,0,0,1,1-.93,1,1,0,0,1,.93,1l-.09,2.87a1,1,0,0,1-1,.93Zm.3-9.57a1,1,0,0,1-.93-1l.09-2.87a1,1,0,1,1,1.92.06l-.09,2.87a1,1,0,0,1-1,.92Zm.3-9.56a1,1,0,0,1-.93-1l.09-2.87a1,1,0,0,1,1.91.06l-.09,2.87a1,1,0,0,1-1,.93Zm.29-9.57a.94.94,0,0,1-.92-1l.09-2.87a.93.93,0,0,1,1-.93,1,1,0,0,1,.93,1l-.09,2.87a1,1,0,0,1-1,.92Zm.3-9.56a1,1,0,0,1-.93-1l.09-2.87a.94.94,0,0,1,1-.92,1,1,0,0,1,.93,1l-.09,2.87a1,1,0,0,1-1,.93Zm.3-9.56a1,1,0,0,1-.93-1l.09-2.87a1,1,0,1,1,1.91.06l-.09,2.87a1,1,0,0,1-1,.93Zm.29-9.57a1,1,0,0,1-.92-1l.09-2.87a1,1,0,1,1,1.91.06l-.09,2.87a1,1,0,0,1-1,.92Zm.3-9.56a1,1,0,0,1-.93-1l.09-2.87a1,1,0,0,1,1.92.06l-.09,2.87a1,1,0,0,1-1,.93Zm.3-9.57a1,1,0,0,1-.93-1l.09-2.87a.94.94,0,0,1,1-.93,1,1,0,0,1,.92,1l-.09,2.87a.94.94,0,0,1-1,.92Zm.29-9.56a1,1,0,0,1-.92-1l.09-2.87a.92.92,0,0,1,1-.92,1,1,0,0,1,.93,1l-.09,2.87a1,1,0,0,1-1,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1222.7,232.6v-2.87a1,1,0,0,1,1.91,0v2.87a1,1,0,1,1-1.91,0Zm0-9.56v-2.87a1,1,0,1,1,1.91,0V223a1,1,0,0,1-1.91,0Zm0-9.57V210.6a1,1,0,1,1,1.91,0v2.87a1,1,0,0,1-1.91,0Zm0-9.57V201a1,1,0,1,1,1.91,0v2.87a1,1,0,1,1-1.91,0Zm0-9.57v-2.87a1,1,0,1,1,1.91,0v2.87a1,1,0,1,1-1.91,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1489.84,253.44a1.44,1.44,0,0,0,1.43-1.31L1506.69,70a1.44,1.44,0,0,0-2.86-.24l-15.42,182.15a1.43,1.43,0,0,0,1.3,1.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1509.63 75.97 1505.19 70.71 1499.93 75.15 1500.28 71.03 1505.54 66.59 1509.97 71.85 1509.63 75.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1185.4,244.94h316a1.44,1.44,0,1,0,0-2.87h-316a1.44,1.44,0,1,0,0,2.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1191.12 248.37 1186.25 243.51 1191.12 238.64 1186.98 238.64 1182.12 243.51 1186.98 248.37 1191.12 248.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1513,136.26l-83.83-33.45-6.46,14.88,80.58,33.38S1514.45,150,1513,136.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1429.12,102.81c2.47,8.23-6.46,14.88-6.46,14.88l-15.2-11.83a36.42,36.42,0,0,0,1.6-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1409.06,99.34a36.42,36.42,0,0,1-1.6,6.52l-11.24-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1499.92,243.39c19.08,35.52,50.76,71.76,102.3,81.48,47.58,9,133,20,167.36,24.37a42,42,0,0,1,26.51,14.19c27,31.17,86.33,116.75,16.57,203-8.92-4.95-21.6-12.89-30.21-22.08,7.71-21.74,8.35-49.52-7.82-83.59a78.87,78.87,0,0,1-2.06,8c-22.28,70.58-23.47,129.31-23.42,142.84,0,1.84-1,3.93-2.8,4.18-38.59,5.25-111.08.92-111.08.92,13.38-66.54-37-183.54-50-212.16a18.48,18.48,0,0,0-9.25-9.19c-72-32.61-103.32-82.78-116-128C1471,252.62,1488.05,246.18,1499.92,243.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1460,267.37c-15.4-54.8-3.42-102.29-3.42-102.29H1473a265.7,265.7,0,0,0,26.89,78.31C1488.05,246.18,1471,252.62,1460,267.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1467.25,173.82s25-32.38,16.87-49.25-36-15.22-36-15.22l-3.9,13.21a16.63,16.63,0,0,0,.39,10.59L1460,173.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1718.9,284.43l5.65,57.73s-32.48,9.79-56.1-6.88l16.61-52.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1681.22,218.63c-.79.74-33,64-33,64l36.5,17.62,39.43-55.41S1694.3,206.32,1681.22,218.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1708,246.36a5.85,5.85,0,0,1-.44,5.12l-18.2,30.35a6,6,0,0,1-1,1.24c-2.17,2-9.58,7.88-15.32-.11-4.88-6.8-9.47-13-14.38-15.55a5.81,5.81,0,0,0-7.85,2.59,217,217,0,0,0-12.46,29.55,5.79,5.79,0,0,0,3.37,7.11c7.39,3,22,8.41,35,10.2a5.81,5.81,0,0,0,5.51-2.34c5.58-7.64,21.29-29,26.66-34.34,5-5,14.18-3.09,18.33-1.9a5.84,5.84,0,0,0,4.65-.61c4.21-2.53,11.54-8.84,4.83-19.52a5.83,5.83,0,0,1,1.8-7.92c4.7-3.08,9.79-8.88,4.94-18.27s-13.69-10.36-19.67-9.63a6,6,0,0,1-6.34-3.53,3.83,3.83,0,0,0-3-2.36,5.66,5.66,0,0,1-4.57-6.64c1-5.38.26-12.37-8.33-17.09-15.75-8.66-29.54,5.45-33,17.36s14.1,20.33,25.18,21.74C1701.75,232.84,1706.22,241.72,1708,246.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1702,291.33s7-20.49,16-19.74,16,9.68,4.91,19.72C1709.08,303.8,1702,291.33,1702,291.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1777.59,455.47c11.82-32.34,7.53-71.39,7.48-71.78l-3.25.37c0,.38,4.24,38.69-7.31,70.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1782.45,544.34c8.61,9.19,21.29,17.13,30.21,22.08-13.32,16.47-25.38,28.83-49.24,45l-2.55,5.05-37.31,1.28S1768,585.08,1782.45,544.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1581.45,574.54l-.28-2.35v0a.61.61,0,0,1,1.22-.15h0l.27,2.41a.6.6,0,0,1-.53.66.6.6,0,0,1-.66-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1578.83,560.53l-.6-2.31h0a.7.7,0,0,1,.5-.86.72.72,0,0,1,.86.51h0l.58,2.34a.69.69,0,0,1-1.33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1574.57,546.9l-.86-2.21v0a.79.79,0,1,1,1.47-.57h0l.84,2.26a.78.78,0,0,1-1.45.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1568.77,533.88l-1.13-2.09v0a.89.89,0,0,1,.37-1.19.88.88,0,0,1,1.19.36h0l1.12,2.14a.87.87,0,0,1-1.54.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1561.35,521.74l-1.4-1.92v0a1,1,0,0,1,1.57-1.14h0l1.4,2a1,1,0,0,1-.23,1.33.94.94,0,0,1-1.32-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1552.27,510.82l-1.67-1.67,0,0a1.05,1.05,0,0,1,0-1.5,1.07,1.07,0,0,1,1.5,0h0l1.69,1.73a1,1,0,0,1-1.49,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1541.58,501.53l-1.93-1.37,0,0a1.15,1.15,0,1,1,1.33-1.87h0l2,1.42a1.14,1.14,0,0,1-1.32,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1529.48,494.19l-2.12-1h0a1.24,1.24,0,0,1,1.07-2.24h0l2.17,1.07a1.22,1.22,0,0,1-1.06,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1516.34,489l-2.27-.66h0a1.33,1.33,0,0,1,.75-2.55h0l2.32.71a1.31,1.31,0,0,1-.75,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1502.54,485.79l-2.34-.34h0a1.38,1.38,0,0,1,.4-2.73h0l2.4.37a1.36,1.36,0,0,1,1.14,1.56,1.38,1.38,0,0,1-1.55,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1488.42,484.48l-2.37-.06h0a1.42,1.42,0,0,1-1.39-1.46,1.44,1.44,0,0,1,1.46-1.4h0l2.42.08a1.42,1.42,0,0,1-.08,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1474.21,484.76l-2.37.19h0a1.48,1.48,0,0,1-.23-2.95h0l2.41-.17a1.47,1.47,0,0,1,.22,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1460.07,486.38l-2.35.39h0a1.53,1.53,0,0,1-.49-3h0l2.38-.37a1.52,1.52,0,0,1,.49,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1446.08,489.11l-2.32.54h0a1.58,1.58,0,0,1-.73-3.08h0l2.35-.54a1.57,1.57,0,0,1,.71,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1432.28,492.74l-2.28.68h0a1.63,1.63,0,0,1-.93-3.12h0l2.31-.67a1.62,1.62,0,0,1,.92,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1418.69,497.13l-2.24.8h0a1.68,1.68,0,0,1-1.12-3.16h0l2.27-.79a1.67,1.67,0,0,1,1.11,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1405.31,502.16l-2.21.89h0a1.73,1.73,0,0,1-1.29-3.21h0L1404,499a1.72,1.72,0,1,1,1.28,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1392.14,507.73l-2.18,1h0a1.78,1.78,0,1,1-1.46-3.24h0l2.2-1a1.77,1.77,0,0,1,1.44,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1379.08,513.7l-2.2,1a1.82,1.82,0,1,1-1.47-3.33h0l2.18-.95h0a1.82,1.82,0,0,1,1.46,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1365.73,519.24l-2.24.86a1.84,1.84,0,1,1-1.32-3.43h0l2.23-.84h0a1.84,1.84,0,1,1,1.31,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1352.18,524.2l-2.28.78a1.85,1.85,0,0,1-1.2-3.51h0l2.25-.77h0a1.85,1.85,0,0,1,1.2,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1338.47,528.68l-2.3.71a1.86,1.86,0,1,1-1.09-3.56h0l2.28-.7h0a1.86,1.86,0,0,1,1.09,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1324.65,532.77l-2.32.65a1.87,1.87,0,1,1-1-3.61h0l2.29-.64h0a1.87,1.87,0,0,1,1,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1310.73,536.51l-2.32.6a1.9,1.9,0,0,1-2.3-1.37,1.88,1.88,0,0,1,1.36-2.29h0l2.32-.59h0a1.88,1.88,0,0,1,.93,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1296.74,540l-2.33.54a1.9,1.9,0,1,1-.87-3.7h0l2.33-.54h0a1.9,1.9,0,0,1,.86,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1282.69,543.1l-2.35.5a1.91,1.91,0,0,1-.79-3.74h0l2.33-.49a1.91,1.91,0,1,1,.8,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1268.59,546l-2.36.46a1.92,1.92,0,0,1-.74-3.77h0l2.35-.45a1.92,1.92,0,0,1,.74,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1254.44,548.66l-2.36.42a1.94,1.94,0,1,1-.68-3.81h0l2.36-.41a1.93,1.93,0,1,1,.68,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1240.25,551.1l-2.37.38a1.94,1.94,0,1,1-.62-3.84h0l2.36-.38a1.95,1.95,0,1,1,.63,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1225.87,553.34l-2.38.35a2,2,0,0,1-.57-3.88h0l2.37-.34a2,2,0,0,1,.57,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1211.35,555.39l-2.38.31a2,2,0,0,1-.52-3.91h0l2.37-.31a2,2,0,0,1,.52,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1196.71,557.23l-2.38.29a2,2,0,0,1-.47-3.94h0l2.38-.27a2,2,0,1,1,.46,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1182.41,558.84l-2.39.25a2,2,0,1,1-.41-4h0l2.38-.25a2,2,0,0,1,.42,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1168.08,560.25l-2.39.22a2,2,0,1,1-.36-4h0l2.38-.21a2,2,0,1,1,.36,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1153.74,561.47l-2.39.19a2,2,0,0,1-.31-4h0l2.38-.18a2,2,0,1,1,.31,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1139.38,562.5l-2.39.16a2,2,0,0,1-.26-4.06h0l2.38-.15a2,2,0,1,1,.26,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1125,563.34l-2.4.12a2,2,0,1,1-.21-4.08h0l2.39-.12a2,2,0,0,1,.21,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1110.64,564l-2.4.08a2,2,0,0,1-2.13-2,2.06,2.06,0,0,1,2-2.14h0l2.39-.08a2.06,2.06,0,0,1,.16,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1096.25,564.42l-2.4.05a2,2,0,1,1-.09-4.09l2.39-.06a2.05,2.05,0,0,1,.11,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1081.86,564.64l-2.4,0a2,2,0,0,1,0-4.07l2.39,0a2,2,0,1,1,0,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1067.46,564.67l-2.4,0a2,2,0,1,1,0-4h2.39a2,2,0,0,1,0,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1053.06,564.48l-2.39-.05a2,2,0,0,1,.08-4l2.39.05a2,2,0,0,1-.07,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1038.67,564.07l-2.4-.09a2,2,0,1,1,.16-4l2.38.08a2,2,0,1,1-.13,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1024.29,563.44l-2.4-.12a2,2,0,1,1,.22-4l2.38.12a2,2,0,0,1-.19,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1009.91,562.58l-2.39-.17a2,2,0,1,1,.28-3.94l2.38.16a2,2,0,1,1-.26,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M995.56,561.47l-2.39-.21a2,2,0,1,1,.34-3.91l2.38.2a2,2,0,1,1-.32,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M981.22,560.1l-2.39-.25a2,2,0,0,1,.41-3.89h0l2.37.25h0a2,2,0,0,1,1.74,2.15,1.94,1.94,0,0,1-2.15,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M966.91,558.46l-2.38-.3a1.94,1.94,0,1,1,.48-3.85h0l2.37.29h0a1.94,1.94,0,1,1-.48,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M952.63,556.53l-2.38-.35a1.93,1.93,0,0,1,.57-3.82h0l2.36.35h0a1.93,1.93,0,0,1-.56,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M938.4,554.29l-2.37-.4a1.92,1.92,0,1,1,.64-3.78h0l2.35.4h0a1.92,1.92,0,0,1-.64,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M924.21,551.73l-2.35-.46a1.91,1.91,0,1,1,.73-3.75h0l2.35.46h0a1.91,1.91,0,0,1-.72,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M910.1,548.8l-2.35-.52a1.9,1.9,0,0,1,.83-3.7h0l2.33.52h0a1.89,1.89,0,1,1-.82,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M896.06,545.5l-2.33-.59a1.88,1.88,0,1,1,.93-3.65h0l2.32.58h0a1.89,1.89,0,1,1-.92,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M882.12,541.77l-2.31-.66a1.87,1.87,0,0,1,1-3.6h0l2.3.65h0a1.88,1.88,0,0,1-1,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M868.31,537.6l-2.29-.75a1.86,1.86,0,1,1,1.15-3.53h0l2.27.73h0a1.86,1.86,0,1,1-1.14,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M854.65,532.92l-2.25-.83a1.85,1.85,0,0,1,1.27-3.47h0l2.24.82h0a1.85,1.85,0,1,1-1.27,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M841.19,527.7l-2.22-.93a1.83,1.83,0,1,1,1.41-3.38h0l2.2.91h0a1.84,1.84,0,1,1-1.41,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M828,521.87l-2.18-1a1.81,1.81,0,0,1,1.56-3.27h0l2.15,1h0a1.82,1.82,0,0,1-1.55,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M815.05,515.36l-2.11-1.15a1.78,1.78,0,1,1,1.7-3.12h0l2.1,1.13h0a1.78,1.78,0,1,1-1.69,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M802.53,508.12l-2-1.29a1.74,1.74,0,1,1,1.85-2.95h0l2,1.25h0a1.75,1.75,0,1,1-1.85,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M790.49,500.07l-2-1.43a1.71,1.71,0,1,1,2-2.75h0l1.92,1.39h0a1.72,1.72,0,0,1,.38,2.39,1.7,1.7,0,0,1-2.39.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M779.06,491.15l-1.83-1.58A1.67,1.67,0,0,1,779.4,487h0l1.81,1.54h0a1.67,1.67,0,0,1-2.17,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M768.41,481.3l-1.69-1.74a1.63,1.63,0,0,1,2.34-2.28l0,0,1.66,1.69,0,0a1.64,1.64,0,0,1-2.35,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M758.72,470.48l-1.51-1.89a1.6,1.6,0,1,1,2.5-2h0l1.48,1.85v0a1.6,1.6,0,1,1-2.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M750.19,458.72l-1.29-2.05a1.56,1.56,0,1,1,2.64-1.67v0l1.28,2v0a1.56,1.56,0,0,1-2.64,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M743,446.07l-1-2.18a1.53,1.53,0,1,1,2.75-1.33v0l1,2.13,0,0a1.53,1.53,0,0,1-2.76,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M737.38,432.68l-.78-2.3a1.48,1.48,0,0,1,.92-1.89,1.5,1.5,0,0,1,1.9.93v0l.77,2.23v0a1.5,1.5,0,0,1-2.83,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M733.35,418.72l-.52-2.37a1.46,1.46,0,0,1,2.85-.62v0l.52,2.31v0a1.46,1.46,0,0,1-2.85.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M730.92,404.4l-.25-2.4a1.42,1.42,0,0,1,2.82-.3v0l.25,2.35v0a1.43,1.43,0,0,1-2.84.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M730,389.93v-2.42a1.39,1.39,0,0,1,2.77,0v0l0,2.37v0a1.39,1.39,0,0,1-2.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M730.54,375.45l.21-2.4a1.34,1.34,0,0,1,1.46-1.23,1.35,1.35,0,0,1,1.23,1.46h0l-.2,2.37v0a1.36,1.36,0,0,1-1.46,1.24,1.35,1.35,0,0,1-1.24-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M732.3,361.09l.4-2.38a1.3,1.3,0,0,1,2.57.43h0l-.38,2.35v0a1.32,1.32,0,0,1-2.6-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M735.16,346.92l.57-2.34a1.24,1.24,0,0,1,2.42.58h0l-.54,2.32h0a1.25,1.25,0,1,1-2.43-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M739,333l.72-2.3a1.18,1.18,0,0,1,2.25.69h0l-.69,2.28v0A1.19,1.19,0,1,1,739,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M743.57,319.32l.84-2.26a1.11,1.11,0,0,1,2.09.77h0l-.81,2.24h0a1.12,1.12,0,1,1-2.11-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M748.87,305.91l.94-2.21a1.05,1.05,0,0,1,1.94.82h0l-.91,2.21h0a1.06,1.06,0,1,1-2-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M754.76,292.76l1-2.16a1,1,0,1,1,1.78.84h0l-1,2.16h0a1,1,0,1,1-1.81-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M761.18,279.87l1.11-2.13a.93.93,0,0,1,1.64.86l-1.09,2.12a.92.92,0,0,1-1.25.42.94.94,0,0,1-.42-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M768.05,267.22l1.18-2.09a.86.86,0,0,1,1.5.85l-1.16,2.09a.87.87,0,0,1-1.53-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M775.31,254.8l1.25-2.05a.8.8,0,0,1,1.1-.27.81.81,0,0,1,.27,1.09l-1.23,2.06a.81.81,0,1,1-1.39-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M782.93,242.59l1.3-2a.74.74,0,0,1,1.24.79l-1.28,2a.74.74,0,1,1-1.26-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M790.86,230.59l1.35-2a.67.67,0,0,1,.93-.18.67.67,0,0,1,.18.93l-1.33,2a.68.68,0,1,1-1.13-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M799.07,218.78l1.39-1.95a.62.62,0,0,1,.85-.14.61.61,0,0,1,.14.85l-1.37,2a.62.62,0,1,1-1-.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "800.58 186.49 808.84 206.87 819.09 192.51 800.58 186.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M887.46,137.65,852,208.22a5.56,5.56,0,0,1-7.65,2.38l-69.52-38.27a2.23,2.23,0,0,1,.49-4.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "800.59 186.49 887.46 137.65 811.79 192.7 813.84 198.45 800.59 186.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "818.45 196.34 808.84 206.87 811.79 192.7 818.45 196.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness1);
export default __webpack_public_path__ + "static/media/business_1.9b995cd906c9383840f9ddbc48f972cf.svg";
export { ForwardRef as ReactComponent };